import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkMfaStatusUpdateProgress,
    stopUpdateMfaJob,
    updateMfaStatus,
} from 'src/openapi/admin/apis/BulkUpdateMfaStatusApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    MFA_SETTINGS_MODAL_TITLES,
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
} from '../constants';
import {
    selectUpdateMfaSettingsTask,
    selectUpdateMfaSettingsUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from '../update-mfa.slice';

import {UpdateMfaSettingsModal} from './update-mfa-settings.modal';

import type {UpdateMfaRequest} from 'src/openapi/admin/models/UpdateMfaRequest';

type Props = {
    shown: boolean,
    usersIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const DisableMfaSettingsTool = ({shown, usersIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateMfaRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={MFA_SETTINGS_MODAL_TITLES.DISABLE_MFA_SETTINGS}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateMfaSettingsTask}
            uuidSelector={selectUpdateMfaSettingsUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(request, options) => (
                apiDispatch(updateMfaStatus({...options, updateMfaRequest: request}))
            )}
            getProgress={id => apiDispatch(bulkMfaStatusUpdateProgress({id}))}
            stopAction={id => apiDispatch(stopUpdateMfaJob({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateMfaSettingsModal {...{usersIds, onCloseModal, processAction, updateStatus: false}}/>
            )}
        </BulkActionTool>
    );
};
